module.exports = __webpack_public_path__ + "static/6-16bec3b7170cc78efbd885d34ac74d26.jpg";